<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><span class="smallcaps">TO</span></span></p>
<p class="ded1"><span>W<span class="smallcaps">ILLIAM</span> G<span class="smallcaps">ILLETTE</span></span></p>
<p class="ded1"><span>F<span class="smallcaps">REDERIC</span> D<span class="smallcaps">ORR</span> S<span class="smallcaps">TEELE</span></span></p>
<p class="ded1"><span><span class="smallcaps">AND</span></span></p>
<p class="ded1"><span>G<span class="smallcaps">RAY</span> C<span class="smallcaps">HANDLER</span> B<span class="smallcaps">RIGGS IN</span></span></p>
<p class="ded1"><span>G<span class="smallcaps">RATITUDE</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ffd52d68